import { render, staticRenderFns } from "./gold.vue?vue&type=template&id=7bbaa1c7&scoped=true"
import script from "./gold.vue?vue&type=script&lang=js"
export * from "./gold.vue?vue&type=script&lang=js"
import style0 from "./gold.vue?vue&type=style&index=0&id=7bbaa1c7&prod&lang=less"
import style1 from "./gold.vue?vue&type=style&index=1&id=7bbaa1c7&prod&lang=less&scoped=true"
import style2 from "./gold.vue?vue&type=style&index=2&id=7bbaa1c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbaa1c7",
  null
  
)

export default component.exports